export const demoInventoryTourIdSelector = () => {
  const demo = window.swag.demo || {};
  return demo.tour;
};
export const demoInventoryIdSelector = () => {
  const demo = window.swag.demo || {};
  return demo.demoInventory || null;
};